import { Alert, Box } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { formatDate } from '~/lib/datetime';
import type { AlertMessage__Show as Show } from './alert-message.generated';

/* GraphQL */ `#graphql
fragment AlertMessage__Show on Show {
  id
  eventDeviceGroups {
    id
    deviceGroup {
      id
      name
      deviceCount
    }
    event {
      id
      name
      start
    }
    show {
      id
      name
    }
  }
  origin {
    id
  }
}
`;

// Generic component name in case need to display other messages for shows.
export const AlertMessage = ({ show }: { show: Show }) => {
  const { t } = useTranslation();
  const { event, deviceGroup } = useMemo(() => {
    const segd = show.eventDeviceGroups.find((x) => x.show.id === show.id);
    const event = segd?.event;
    const deviceGroup = segd?.deviceGroup;
    return { event, deviceGroup };
  }, [show]);

  return show.origin && event && deviceGroup ? (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info">
        <Trans
          i18nKey="pages.shows.components.alert_message"
          values={{
            eventName: event.name,
            eventStart: formatDate(event.start, { format: DateTime.DATETIME_MED }),
            deviceCount: deviceGroup.deviceCount,
            devicePlural: t('common.pluralize.device_plural', { count: deviceGroup.deviceCount }),
            deviceGroupName: deviceGroup.name,
          }}
          components={{ strong: <strong /> }}
        />
      </Alert>
    </Box>
  ) : null;
};
